import {
  // Facebook,
  Instagram,
  Mail,
  MapPin,
  Phone,
  Youtube,
} from "lucide-react";
import { useState } from "react";
import { WHATSAPP_NUMBER } from "../config";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  async function sendToWhatsapp(name, email, mobile, message) {
    const whatsappMessage = `New Website Inquiry 🚀
Name: ${name}
Mobile: ${mobile}
Email: ${email}
Message: ${message}`;

    const encodedMessage = encodeURIComponent(whatsappMessage);

    window.open(
      `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`,
      "_blank",
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbwzTPsYWeURuMB_ovdL3CsxaYdJ4MzL-SitOScldDIYCeY6aJyHkT6ale-5Ij6NVxLbug/exec",
        {
          method: "POST",
          body: JSON.stringify(form),
        },
      );
      sendToWhatsapp(form.name, form.email, form.phone, form.message);
      setForm({
        name: "",
        email: "",
        phone: "",
        message: "",
      });

      setSuccess(true);
    } catch (error) {
      alert("Something went wrong. Please try again.");
    }

    setLoading(false);
  };

  return (
    <section className="py-24 bg-royal-blue text-white" id="contact">
      <div className="mx-7 px-4 grid lg:grid-cols-2 gap-16">
        {/* Left Info Section */}
        <div>
          <h2 className="font-display gold-gradient-text text-4xl mb-6">
            CONNECT WITH THE ACADEMY
          </h2>

          <p className="text-slate-300 mb-6">
            Have questions about our training programs or want to book the band
            for an upcoming royal event? Our team is ready to assist you.
          </p>

          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <Phone className="text-primary" size={22} />
              <a
                href="tel:+919817196061"
                className="hover:text-primary underline"
              >
                +91 981 719 6061
              </a>
            </div>

            <div className="flex items-center gap-3">
              <Mail className="text-primary" size={22} />
              <span>Dhuria.panky@gamil.com</span>
            </div>

            <div className="flex items-center gap-3">
              <MapPin className="text-primary" size={22} />
              <span>Haryana, India</span>
            </div>
          </div>

          {/* Social Media Links */}
          <div className="pt-6">
            <h4 className="text-lg font-semibold mb-3">Follow Us</h4>

            <div className="flex flex-wrap gap-4">
              {/* Instagram */}
              <a
                href="https://www.instagram.com/royal_bagpipe_academy?igsh=c2Fvbm04NGk3MzJy"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-5 py-2 rounded-lg text-white 
    bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 
    hover:scale-105 transition transform shadow-md"
              >
                <Instagram size={20} />
                Instagram
              </a>

              {/* Facebook */}
              {/* <a
                href="https://facebook.com/YOUR_FACEBOOK_PAGE"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-5 py-2 rounded-lg text-white 
                  bg-[#1877F2] hover:bg-[#1664d9] 
                  hover:scale-105 transition transform shadow-md"
              >
                <Facebook size={20} />
                Facebook
              </a> */}

              {/* YouTube */}
              <a
                href="https://www.youtube.com/@royal_bagpipe_academy"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-5 py-2 rounded-lg text-white 
                bg-[#FF0000] hover:bg-[#cc0000] 
                hover:scale-105 transition transform shadow-md"
              >
                <Youtube size={20} />
                YouTube
              </a>
            </div>
          </div>
        </div>

        {/* Right Form Section */}
        <div className="bg-white p-8 rounded-xl text-slate-900 shadow-xl">
          <h3 className="font-display text-2xl text-royal-blue mb-6">
            CONTACT US
          </h3>

          <form className="space-y-6" onSubmit={handleSubmit}>
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              required
              type="text"
              className="w-full border p-3 rounded focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="Full Name"
            />

            <input
              name="phone"
              value={form.phone}
              onChange={handleChange}
              type="number"
              required
              className="w-full border p-3 rounded focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="Mobile Number"
            />

            <input
              name="email"
              value={form.email}
              onChange={handleChange}
              type="email"
              className="w-full border p-3 rounded focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="Email"
            />

            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              required
              rows="4"
              className="w-full border p-3 rounded focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="Your Message"
            />

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className={`w-full py-3 rounded flex justify-center items-center gap-2 transition font-semibold
                ${
                  loading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-royal-blue hover:bg-slate-800 text-white"
                }`}
            >
              {loading ? (
                <>
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v8z"
                    ></path>
                  </svg>
                  Sending...
                </>
              ) : (
                "Send Inquiry"
              )}
            </button>

            {/* Success Message */}
            {success && (
              <div className="text-green-600 text-sm mt-3">
                Inquiry submitted successfully!
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
